import styled from 'styled-components'

const FacebookCommentsUi = styled.img`
  object-fit: scale-down;
`

export default FacebookCommentsUi
